import React, {Component} from 'react';
import { connect } from 'react-redux';

class ErrorMessage extends Component{



	render(){
		//HTML comes directly from the IMIS plugin. It's something we set. So nothing malicious to worry about.
		return(
			<div className="login_err"><p dangerouslySetInnerHTML={{ __html: this.props.message }}></p></div>
		)



	}


}


export default connect (null)(ErrorMessage)